var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"container"},[_c('h2',{class:[
        'h2-title text-uppercase',
        {
          'h2-title--light': _vm.textLight,
        },
      ]},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.secondTitle)?_c('div',[_vm._v(_vm._s(_vm.secondTitle))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }